<template>
  <div class="login-page" v-on:keyup.enter=login>
    <vue-particles
      style="position: absolute;top: 0;bottom: 0;left: 0;right: 0"
      color="#fff"
      :particleOpacity="0.7"
      :particlesNumber="100"
      shapeType="circle"
      :particleSize="4"
      linesColor="#fff"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
      class="lizi"/>
    <a-row :gutter="15" style="margin-top: 25vh">
      <a-col :md="{span:6,offset:9}" :sm="{span:12,offset:6}" :xs="{span:24,offset:0}">
        <div class="login-form-wrap">
          <div style="text-align: center">
          <div class="logo-wrap">
            LAMA
          </div>
          </div>
          <a-form-model
            ref="form"
            :model="form.data"
            :rules="form.rule"
            v-on:keyup.enter=showCaptchaBox
          >
            <a-form-model-item :title="$t('LOGIN_NAME')||'账号'" prop="loginName">
              <a-input
                size="large"
                v-model="form.data.loginName"
                :disabled="form.disabled"
              >
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :title="$t('PASSWORD')||'密码'" prop="password">
              <a-input-password
                size="large"
                v-on:keyup.enter=showCaptchaBox
                v-model="form.data.password"
                :disabled="form.disabled"
                show-password>
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
              </a-input-password>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                size="large"
                style="background-color:rgba(19,20,18,0.8);
                      border-radius: 8px;
                      margin-top:15px;
                      color:rgb(255,255,255)
                     "
                block
                @click="showCaptchaBox"
                v-on:keyup.enter=showCaptchaBox
                :disabled="form.disabled">
                {{ $t('LOGIN') || '登录' }}
                <i class="el-icon-arrow-right el-icon--right" v-if="!form.disabled"/>
                <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
              </a-button>
              <language-switch
              style="float: right;
                      margin-top: 10px;
                                    "/>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-col>
    </a-row>

    <verify
    ref="verify"
    :mode="'pop'"
    :captcha-type="'blockPuzzle'"
    :img-size="{width:'300px',height:'155px'}"
    @success="captchaVerifySuccess"/>
  </div>
</template>

<script>
import {
  _login,
} from '@/api/loginApi';
import LanguageSwitch from '@/components/LanguageSwitch.vue';
import Verify from '../../components/vertification/Verify.vue';

async function login() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      this.form.disabled = true;
      const result = await _login({
        loginName: this.form.data.loginName,
        password: this.form.data.password,
      });
      if (result && result) {
        this.$store.commit('setLoginInfo', {
          userName: result.loginName,
          token: result.token,
        });
        localStorage.setItem('roles', JSON.stringify(result.roles));
        localStorage.setItem('id', result.roles[0].id);
        const menus = result.menus.filter(menu => menu.type === 'MENU')
          .sort((a, b) => a.sort.localeCompare(b.sort));
        localStorage.setItem('MENUS', JSON.stringify(menus));
        const BUTTON = result.menus.filter(menu => menu.type === 'BUTTON')
          .map(x => x.code);
        localStorage.setItem('BUTTONS', JSON.stringify(BUTTON));
        await this.$router.push('/');
        return;
      }
      this.$message.error(this.$t('LOGIN_ERROR'));
      this.form.disabled = false;
    }
  });
}

function captchaVerifySuccess(verifyParams) {
  this.login();
}

async function showCaptchaBox() {
  // this.$refs.verify.show();
  this.login();
}

export default {
  name: 'Login',
  components: { LanguageSwitch,
    Verify },
  methods: {
    login,
    showCaptchaBox,
    captchaVerifySuccess,
  },
  mounted() {
  },
  data() {
    return {
      autoLogin: false,
      form: {
        disabled: false,
        data: {
          loginName: null,
          password: null,
        },
        rule: {
          loginName: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          }],
        },
      },
    };
  },
};
</script>

<style>
.login-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0e1016;
  overflow: hidden;

  /*background-image: url("../../assets/background.jpg");*/
  background-repeat: no-repeat;
  background-origin: content-box;
  background-size: cover;
}

.login-page .a-form-model-item__label {
  color: #ffffff;
}

.login-form-wrap {
  border-radius: 5px;
  background: #ffffff24;
  padding: 40px;
  /* background:raga(0,0,0); */
  box-shadow: #ffffffb4 0px 0px 15px 5px;
}

.logo-wrap{
  margin-bottom: 30px;
  text-align: center;
  font-size: 50px;
  color:  white;
  font-weight: bold;

}

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  /*background-image: linear-gradient(122deg, #000000 0%, #52383d 27%, #ffffff 100%);*/

}
</style>
